<template>
  <tabs
    :value="current_tab"
    :animated="false"
    class="ivu-tabs-no-padding"
    @on-click="refresh_scroll"
  >
    <tab-pane
      name="contact_methods"
      :label="$t(`pbx.worksheet.action.queue.input.contact_methods.label`)"
    >
      <list-scroll v-if="selected_methods.length" height="200px">
        <div class="w-100">
          <contact-method-with-contact
            v-for="item in selected_methods"
            :key="item.id"
            :method="item"
            :contact="item.contact"
          >
            <table-control slot="controls" type="trash" @click="remove_method(item.id)" />
          </contact-method-with-contact>
        </div>
      </list-scroll>

      <i-button
        type="primary"
        size="large"
        icon="md-add"
        class="mt-2"
        @click="set_step('add-method')"
      >
        {{ $t(`pbx.worksheet.action.queue.state.add-method.title`) }}
      </i-button>
    </tab-pane>

    <tab-pane
      name="contact_groups"
      :label="$t(`pbx.worksheet.action.queue.input.contact_groups.label`)"
    >
      <group-with-count v-for="item in selected_groups" :key="item.id" :item="item">
        <table-control slot="controls" type="trash" @click="remove_group(item.id)" />
      </group-with-count>

      <i-button
        type="primary"
        size="large"
        icon="md-add"
        class="mt-2"
        @click="set_step('add-group')"
      >
        {{ $t(`pbx.worksheet.action.queue.state.add_group.title`) }}
      </i-button>
    </tab-pane>
  </tabs>
</template>

<script>
  import ContactMethodWithContact from '@pbx/components/contact-methods/item-with-contact';
  import GroupWithCount from '@pbx/components/groups/_fragments/item-with-count';

  import vuescroll from 'vuescroll';
  import cloneDeep from 'lodash-es/cloneDeep';

  export default {
    components: { ContactMethodWithContact, GroupWithCount },
    props: {
      current_tab: {
        type: String,
        required: true
      },

      current_contact_methods: {
        type: Array,
        default: () => []
      },

      current_contact_groups: {
        type: Array,
        default: () => []
      },

      list_of_contact_methods: {
        type: Array,
        default: () => []
      },

      list_of_groups: {
        type: Array,
        default: () => []
      }
    },

    computed: {
      selected_methods: function() {
        return this.current_contact_methods
          .map(id => {
            return this.list_of_contact_methods.find(list_item => list_item.id === id);
          })
          .filter(item => item);
      },

      selected_groups: function() {
        return this.current_contact_groups
          .map(id => {
            return this.list_of_groups.find(list_item => list_item.id === id);
          })
          .filter(item => item);
      }
    },

    watch: {
      current_contact_methods: function() {
        this.refresh_scroll();
      },

      current_contact_groups: function() {
        this.refresh_scroll();
      }
    },

    methods: {
      refresh_scroll: function() {
        vuescroll.refreshAll();
      },

      remove_by_id: function(id, array) {
        return array.filter(item => item !== id);
      },

      remove_method: function(id) {
        const ids = this.remove_by_id(id, this.current_contact_methods);
        this.$emit('update:current_contact_methods', cloneDeep(ids));
      },

      remove_group: function(id) {
        const ids = this.remove_by_id(id, this.current_contact_groups);
        this.$emit('update:current_contact_groups', cloneDeep(ids));
      },

      set_step(name) {
        this.$emit('change-step', name);
      }
    }
  };
</script>
